import {Component} from '@angular/core';

@Component({
  selector: 'app-step-two-left-panel',
  templateUrl: './step-two-left-panel.component.html',
  styleUrls: ['./step-two-left-panel.component.css']
})
export class StepTwoLeftPanelComponent {

}
